jQuery(document).ready(function ($) {
	// Simple accordion functionality
	$('.accordion__group button').on('click', function (e) {
		e.preventDefault();

		// If item clicked on is open, close it
		if ($(this).closest('.accordion__group').hasClass('active')) {
			$(this).closest('.accordion__group').removeClass('active');
			$(this)
				.closest('.accordion__group')
				.find('.accordion__copy')
				.slideUp();
		} else {
			// Otherwise, close all others and open the one clicked on
			$(this)
				.closest('.accordion__group')
				.siblings()
				.removeClass('active');
			$(this)
				.closest('.accordion__group')
				.siblings()
				.find('.accordion__copy')
				.slideUp();

			$(this).closest('.accordion__group').addClass('active');
			$(this)
				.closest('.accordion__group')
				.find('> .accordion__copy')
				.slideToggle();
		}
	});

	$('.pdpAccordions__accordionTitle').on('click', function (e) {
		e.preventDefault();
		var accordion = $(this).closest('.pdpAccordions__accordion');
		accordion.toggleClass('pdpAccordions__accordion--open');
		accordion.find('.pdpAccordions__accordionContent').slideToggle();
	});
});
